import {getTime, startOfDay, toDate} from "@/shared/lib/date/core";
import {DAY} from "@/shared/lib/date/config";

export function diff(date1, date2 = new Date()) {
    return getTime(date1) - getTime(date2);
}

export function diffInDays(a, b) {
    const d1 = startOfDay(a);
    const d2 = startOfDay(b);

    return Math.floor((d1 - d2) / DAY);
}

export function diffInMonths(a, b) {
    const d1 = toDate(a);
    const d2 = toDate(b);

    let months =
        (d1.getFullYear() - d2.getFullYear()) * 12 +
        (d1.getMonth() - d2.getMonth());

    // корректировка по дням
    if (d1.getDate() < d2.getDate()) {
        months--;
    }

    return months;
}
